var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dc-xp-container" }, [
    _c(
      "div",
      { staticClass: "dc-xp-message" },
      [
        _c("MeteorIcon", {
          attrs: {
            "trail-color": "#179E7E",
            "meteor-color": "white",
            "meteor-stroke-color": "#179E7E"
          }
        }),
        _vm._v(" "),
        _c("span", [_vm._v("You can earn XP on Daily Challenges once per day")])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        attrs: { type: "button", "aria-label": "Dismiss Leagues XP message" },
        on: {
          click: function($event) {
            return _vm.$emit("dc-xp-modal-dismissed")
          }
        }
      },
      [_c("XIcon", { attrs: { color: "black", translucid: false } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }